// extracted by mini-css-extract-plugin
export var colorSquare = "_ob-0";
export var container = "_ob-h";
export var danger = "_ob-5";
export var lightPink = "_ob-8";
export var neutralBlue = "_ob-7";
export var neutralYellow = "_ob-6";
export var normal = "_ob-1";
export var primary = "_ob-2";
export var primaryLight = "_ob-3";
export var selected = "_ob-i";
export var solidBlack = "_ob-g";
export var solidGreen = "_ob-b";
export var solidLightBlue = "_ob-d";
export var solidNavy = "_ob-c";
export var solidOrange = "_ob-f";
export var solidPink = "_ob-e";
export var solidRed = "_ob-9";
export var solidYellow = "_ob-a";
export var success = "_ob-4";